import { type KeyboardEvent, type ReactNode } from "react";

import { Box, SxProps, Theme, Typography } from "@mui/material";

import {
  getFilterChipIconSx,
  getFilterChipLabelSx,
  getFilterChipRootSx
} from "@/src/components/atoms/FilterChip/filterChip.styles";

interface FilterChipProps {
  label: string;
  icon?: ReactNode;
  isChecked: boolean;
  onToggle: () => void;
  hideLabelOnMobile?: boolean;
  sx?: SxProps<Theme>;
}

const FilterChip = ({
  label,
  icon,
  isChecked,
  onToggle,
  hideLabelOnMobile = false,
  sx
}: FilterChipProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== "Enter" && event.key !== " ") return;

    event.preventDefault();
    onToggle();
  };

  return (
    <Box
      onClick={onToggle}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={isChecked}
      aria-label={label}
      sx={getFilterChipRootSx(isChecked, sx)}
    >
      {icon && <Box sx={getFilterChipIconSx(hideLabelOnMobile)}>{icon}</Box>}
      <Typography
        variant="body2"
        sx={getFilterChipLabelSx(isChecked, hideLabelOnMobile)}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default FilterChip;
